import { DeliveryType } from 'shared-types'

export const getDeliveryTypeName = (collection) => {
  return collection === DeliveryType.DELIVERY ||
    collection === DeliveryType.WAREHOUSE
    ? 'Delivery'
    : 'Click and Collect'
}
